import { io } from 'socket.io-client';

export enum SocketEvent {
  NEW_MESSAGE = 'new-message',
  LOGIN_SUCCESS = 'login-success',
  ADMIN_LOG = 'admin-log',
}

let accessToken: string | null = null;

const eventCallbacks: {
  [key: string]: ((...args: any[]) => void) | undefined;
} = {
  updateSheet: undefined,
};

const socket = io(`${process.env.REACT_APP_SOCKET_URL}`, {
  transports: ['websocket', 'polling'],
  path: '/socket',
});

socket.on('connect', () => {
  if (accessToken) {
    socketLogin(accessToken);
  }
});

export const socketLogin = (token: string) => {
  accessToken = token;
  socket.emit('login', { accessToken });
};

socket.on(SocketEvent.LOGIN_SUCCESS, (data: unknown) => {
  console.log('loginSuccess', data);
});

export const exclusivelySubscribeEvent = (
  event: SocketEvent,
  callback: null | ((...args: any[]) => void)
) => {
  if (eventCallbacks[event]) {
    socket.off(event, eventCallbacks[event]);
  }
  if (callback) {
    socket.on(event, callback);
    eventCallbacks[event] = callback;
  } else {
    delete eventCallbacks[event];
  }
};

export const subscribeEvent = (
  event: SocketEvent,
  callback: (...args: any[]) => void
) => {
  socket.on(event, callback);
};

export const unsubscribeEvent = (event: SocketEvent, cb: any) => {
  socket.off(event, cb);
};

export const getSocketClientId = () => {
  return socket.id;
};
